// src/pages/PrivacyPage.js
import React from 'react';
import { useNavigate, Link } from 'react-router-dom';

const Section = ({ title, children }) => (
  <section className="max-w-4xl mx-auto my-8">
    <h2 className="text-xl font-semibold mb-3">{title}</h2>
    <div className="prose prose-invert max-w-none text-sm leading-6">
      {children}
    </div>
  </section>
);

export default function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <main className="min-h-[calc(100vh-64px)] px-6 py-8">
      <div className="max-w-4xl mx-auto">
        <button
          onClick={() => navigate(-1)}
          className="mb-6 inline-flex items-center rounded-md border border-gray-700 px-3 py-1.5 text-sm hover:bg-gray-800"
        >
          ← Back
        </button>

        <h1 className="text-3xl font-bold">Privacy Policy</h1>
        <p className="mt-2 text-sm text-gray-400">Last updated: {new Date().toLocaleDateString()}</p>
      </div>

      <Section title="1. Overview">
        <p>
          This Privacy Policy explains how Clairifi collects, uses, and protects your information when you
          use our service.
        </p>
      </Section>

      <Section title="2. Information We Collect">
        <ul className="list-disc pl-6">
          <li><strong>Account data</strong> (e.g., name, email, authentication info).</li>
          <li><strong>Usage data</strong> (e.g., pages visited, actions, device info, logs).</li>
          <li><strong>Uploaded files</strong> (e.g., financial CSVs) for analysis and features you request.</li>
        </ul>
      </Section>

      <Section title="3. How We Use Information">
        <ul className="list-disc pl-6">
          <li>Provide, maintain, and improve the service.</li>
          <li>Secure the platform, prevent abuse, and debug issues.</li>
          <li>Communicate about updates, subscriptions, and support.</li>
        </ul>
      </Section>

      <Section title="4. Sharing">
        <p>
          We do not sell your personal information. We may share data with infrastructure and analytics
          providers under contract, or when required by law.
        </p>
      </Section>

      <Section title="5. Data Security & Retention">
        <p>
          We use reasonable safeguards to protect data. Retention depends on your account status, legal
          requirements, and product needs. You may request deletion of account data subject to obligations.
        </p>
      </Section>

      <Section title="6. Your Choices">
        <ul className="list-disc pl-6">
          <li>Access, update, or delete your account information.</li>
          <li>Control communications via email preferences.</li>
          <li>Contact us for data requests at <a className="underline" href="mailto:contact@getclairifi.com">contact@getclairifi.com</a>.</li>
        </ul>
      </Section>

      <Section title="7. Children’s Privacy">
        <p>Clairifi is not directed to children under 13 and we do not knowingly collect their data.</p>
      </Section>

      <Section title="8. Changes to this Policy">
        <p>
          We may update this Privacy Policy. We will post the new version here and update the “Last updated”
          date. Continued use constitutes acceptance.
        </p>
      </Section>

      <Section title="Related">
        <p>
          See also our <Link to="/terms" className="underline">Terms & Conditions</Link>.
        </p>
      </Section>
    </main>
  );
}
